import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  RowLeftText: {
    color: theme.palette.xpl.text.secondary,
    textAlign: 'left',
    display: 'inline-block',
    width: '200px',
  },
  RowRightText: {
    color: theme.palette.xpl.text.primary,
    textAlign: 'left',
  },
  TextRow: {
    padding: '4px 0',
  },
});
const InfoWidgetTextRow = (props) => {
  const { classes, title, value } = props;
  return (
    <div className={classes.TextRow}>
      <span className={classes.RowLeftText}>{title}</span>
      <span className={classes.RowRightText}>{value}</span>
    </div>
  );
};

export default withStyles(styles)(InfoWidgetTextRow);
